import { storeToRefs } from 'pinia'
import { useZenniAlgoliaSearch } from '#imports'
import { useGuestStore } from '~/store/guest'
import type { BaseSearchParams } from '@algolia/client-search'
export const useEmployeeAlgolia = <T>(indexName?: string) => {
  const { currentGift } = storeToRefs(useGuestStore())
  const {
    search: baseSearch,
    result,
    loading,
    searchGetters,
  } = useZenniAlgoliaSearch<T>(indexName)
  const search = async ({
    queryParams,
    includeFrameFilters = true,
    mergeB2C,
    bestSelling,
  }: {
    queryParams: {
      query: string
      requestOptions: BaseSearchParams & {
        attributesToRetrieve?: string[]
      }
    }
    includeFrameFilters?: boolean
    mergeB2C?: boolean
    bestSelling?: boolean
  }) => {
    // we will asume that if no objectType is passed, then we are searching for products
    const filterHasObjectType =
      queryParams.requestOptions.filters?.includes('objectType')
    return await baseSearch(
      {
        ...queryParams,
        requestOptions: {
          ...queryParams.requestOptions,
          filters: `enabled:true AND ${
            queryParams.requestOptions.filters || ''
          }${!filterHasObjectType ? ' AND objectType:"product"' : ''}`,
        },
        catalogFilter: currentGift.value?.catalogFilter,
      },
      includeFrameFilters ? currentGift.value?.frameFilter : undefined,
      mergeB2C,
      bestSelling,
    )
  }
  return {
    search,
    result,
    loading,
    searchGetters,
  }
}
